import { FilterGroup } from '@teetsh/app/src/types/eleves';

interface TableFilter {
  id: string;
  value: unknown;
  operator: string;
}

export function filterGroupTofFilterArray(p: FilterGroup): TableFilter[] {
  return (p?.filterSet || []).map(f => ({
    id: f.columnId,
    value: f.value,
    operator: f.operator,
  }));
}
